import React, { forwardRef, memo } from "react";
import { View } from "react-native";
import { useTab } from "./TabContext";

export const TabPanel = memo(
  forwardRef(
    (
      {
        value,
        children,
        ...props
      }: { value?: string } & React.ComponentProps<typeof View>,
      ref?: React.Ref<View>,
    ) => {
      const { currentActiveTab } = useTab();

      if (value !== currentActiveTab) {
        return null;
      }

      return (
        <View ref={ref} {...props}>
          {children}
        </View>
      );
    },
  ),
);
